// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NG7M","title":"styles_title__iR5c4"};